import { store } from '@/store/index.js'
import { executeHttpCall } from '@/services/httpClientHelper.js'
import { getDtcReportTypes, vehicleEpisodeEventCount, engineEpisodeEventCount} from '@/services/importingJsons.js'

const dxcReport = {
  namespaced: true,
  state: {
    groupSizes: {
      error: false,
      loading: false,
      options: []
    },
    reportTypes: {
      error: false,
      loading: false,
      options: []
    },
    createdInWorkshopOptions: [
      { id: 1, name: 'Both' },
      { id: 2, name: 'Inside workshop' },
      { id: 3, name: 'Outside workshop' }
    ],
    diagnosticEventCodeOptions: [
      { id: 1, name: 'DTC' },
      { id: 2, name: 'DEC' }
    ],
    jsonInBackend: {
      data: null
    },
    selected: {
      unikSoftwareVersions1: [],
      unikSoftwareVersions2: [],
      unikSoftwareVersions3: [],
      unikSoftwareVersions4: [],
      dtcEventOption: true,
      decEventOption: null,
      customReportLink: null,
      groupSizeFrom: null,
      groupSizeTo: null,
      excludeMissingEventTimestamp: false,
      reportType: null,
      includeAllDxcs: false,
      createdInWorkshop: null,
      diagnosticEventCode: null,
      excludeByDaysAfterDelivery: '',
      dateAndMileage: {
        raw: {
          readoutDateFrom: '',
          readoutDateTo: '',
          dwSaveDateFrom: '',
          dwSaveDateTo: '',
          mileageReadoutFrom: null,
          mileageReadoutTo: null,
          includeVehiclesSinceStart: false,
          maximumLoss: null
        },
        formatted: {
          readoutDateFrom: '',
          readoutDateTo: '',
          dwSaveDateFrom: '',
          dwSaveDateTo: '',
          mileageReadoutFrom: null,
          mileageReadoutTo: null,
          includeVehiclesSinceStart: false,
          maximumLoss: null
        }
      },
      ecuProperties: {
        ecuType: '',
        ecus: [],
        assemblyParts: [],
        manufacturerSoftwareVersions: [],
        manufacturerSoftwareNumbers: [],
        supplierSoftwareVersions: [],
        dtcCodes: [],
        decCodes: [],
        ecusOthers: [],
        assemblyPartsOthers: [],
        manufacturerSoftwareVersionsOthers: [],
        manufacturerSoftwareNumbersOthers: [],
        supplierSoftwareVersionsOthers: [],
        dtcCodesOthers: [],
        decCodesOthers: []
      }
    },
    allEcusSelected: false
  },
  mutations: {
    groupSizes (state, payload) {
      state.groupSizes[payload.propName] = payload.value
    },
    reportTypes (state, payload) {
      state.reportTypes[payload.propName] = payload.value
    },
    postReport (state, payload) {
      state.postReport[payload.propName] = payload.value
    },
    selected (state, payload) {
      state.selected[payload.propName] = payload.value
    },
    jsonInBackend (state, payload) {
      state.jsonInBackend[payload.propName] = payload.value
    },
    allEcusSelected (state, payload) {
      state.allEcusSelected = payload
    },
    overwriteSelected (state, newVal) {
      state.selected = newVal
    },
    setDefaultState (state) {
      state.groupSizes = {
        error: false,
        loading: false,
        options: []
      }
      state.reportTypes = {
        error: false,
        loading: false,
        options: []
      }
      state.postReport = {
        error: false,
        loading: false,
        response: null
      }
      state.createdInWorkshopOptions = [
        { id: 1, name: 'Both' },
        { id: 2, name: 'Inside workshop' },
        { id: 3, name: 'Outside workshop' }
      ]
      state.diagnosticEventCodeOptions = [
        { id: 1, name: 'DTC' },
        { id: 2, name: 'DEC' }
      ]
    },
    setDefaultSelectionState (state) {
      state.selected = {
        unikSoftwareVersions1: [],
        unikSoftwareVersions2: [],
        unikSoftwareVersions3: [],
        unikSoftwareVersions4: [],
        customReportLink: null,
        dtcEventOption: true,
        decEventOption: null,
        dxcSelection: [],
        groupSizeFrom: null,
        groupSizeTo: null,
        excludeMissingEventTimestamp: false,
        reportType: null,
        includeAllDxcs: false,
        createdInWorkshop: null,
        excludeByDaysAfterDelivery: '',
        dateAndMileage: {
          raw: {
            readoutDateFrom: '',
            readoutDateTo: '',
            dwSaveDateFrom: '',
            dwSaveDateTo: '',
            mileageReadoutFrom: null,
            mileageReadoutTo: null,
            includeVehiclesSinceStart: false,
            maximumLoss: null
          },
          formatted: {
            readoutDateFrom: '',
            readoutDateTo: '',
            dwSaveDateFrom: '',
            dwSaveDateTo: '',
            mileageReadoutFrom: null,
            mileageReadoutTo: null,
            includeVehiclesSinceStart: false,
            maximumLoss: null
          }
        },
        ecuProperties: {
          ecuType: '',
          ecus: [],
          assemblyParts: [],
          manufacturerSoftwareVersions: [],
          manufacturerSoftwareNumbers: [],
          supplierSoftwareVersions: [],
          dtcCodes: [],
          decCodes: [],
          ecusOthers: [],
          assemblyPartsOthers: [],
          manufacturerSoftwareVersionsOthers: [],
          manufacturerSoftwareNumbersOthers: [],
          supplierSoftwareVersionsOthers: [],
          dtcCodesOthers: [],
          decCodesOthers: []
        }
      }
    }
  },
  getters: {
    isAllEcusSelected: state => {
      return state.allEcusSelected
    },
    getAllSelections: state => {
      return state.selected
    }
  },
  actions: {
    loadStateFromFile ({ commit }, data) {
      commit('overwriteSelected', data)
    },
    getDxcGroupSizes ({ commit, rootGetters }) {
      const productType = rootGetters['population/getProductType']

      commit('groupSizes', { propName: 'options', value: [] })
      commit('groupSizes', { propName: 'error', value: false })
      commit('groupSizes', { propName: 'loading', value: true })

      const featureFunction = () =>{
        if(productType === 'VEHICLE')return  vehicleEpisodeEventCount()
        if(productType === 'ENGINES')return  engineEpisodeEventCount()
      }
        featureFunction().then(result => {
          var resultSorted = result.sort((a, b) => {
            return a.EpisodeEventCount - b.EpisodeEventCount
          })
          const dxcGroupSizes = resultSorted.map(x => {
            return {
              id: x.EpisodeEventCount,
              name: x.EpisodeEventCount
            }
          })
        commit('groupSizes', { propName: 'options', value: dxcGroupSizes })
      }).catch(error => {
        console.log('getEpisodeEventCount: ', error)
        commit('groupSizes', { propName: 'error', value: true })
      }).finally(() => {
        commit('groupSizes', { propName: 'loading', value: false })
      })
  },
    getDxcReportTypes ({ commit }) {
      commit('reportTypes', { propName: 'options', value: [] })
      commit('reportTypes', { propName: 'error', value: false })
      commit('reportTypes', { propName: 'loading', value: true })
      const params = {
        resultFile: 'DtcRepTy',
        _program: 'GetDtcReportTypes'
      }
      getDtcReportTypes().then(result => {
        var report = JSON.parse(JSON.stringify(result).replaceAll('Visual analytics - ', ''))
        if (store.state.dxcReport.selected.decEventOption) {
          // Filtering only first 4 reports if DEC selection is true
          report.splice(4, 10)
          report.splice(1, 1)
          report.splice(2, 1)
        }
        for (var i = 0; i < report.length; i++) {
          report[i].name = report[i].name.replace('DTCs', 'Diagnostic codes')
          report[i].name = report[i].name.replace('DTC', 'Diagnostic codes')
        }

        commit('reportTypes', { propName: 'optionsFiltered', value: report })
        // commit('reportTypes', { propName: 'optionsFiltered', value: JSON.parse(JSON.stringify(result).replaceAll('Visual analytics - ', '').replaceAll('DTC', 'DXC')) })
        commit('reportTypes', { propName: 'options', value: result })
      }).catch(error => {
        console.error('getDxcReportTypes:', error)
        commit('reportTypes', { propName: 'error', value: true })
      }).finally(() => {
        commit('reportTypes', { propName: 'loading', value: false })
      })
    },
    updateSelection ({ commit }, payload) {
      commit('selected', payload)
    },
    reset ({ commit }) {
      commit('setDefaultState')
      commit('setDefaultSelectionState')
    }
  }
}
export default dxcReport
